import React from 'react';

/* eslint-disable react/prop-types */
const formatFilterValue = (config, value) => {
  if (Array.isArray(value)) {
    if (config?.variant === 'number-range' || config?.variant === 'date-range') {
      const [minimum, maximum] = value;
      if (minimum == null && maximum == null) return '';
      return `${minimum ?? '−∞'} – ${maximum ?? '∞'}`;
    }
    return value
      .map((selectedValue) => (
        config?.options?.find((option) => option.value === String(selectedValue))?.label
        || String(selectedValue)
      ))
      .join(', ');
  }

  if (config?.variant === 'boolean') {
    return value ? (config.trueLabel || 'Yes') : (config.falseLabel || 'No');
  }

  return config?.options?.find((option) => option.value === String(value))?.label
    || String(value);
};

const DataTableFilterIndicators = ({
  table,
  globalFilter,
  clearGlobalFilterOnClear,
}) => {
  const columnFilters = table.getState().columnFilters;
  const activeFilters = columnFilters.flatMap(({ id, value }) => {
    if (value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) return [];
    const column = table.getColumn(id);
    if (!column) return [];
    const config = column.columnDef.meta?.filter;
    const label = config?.label || id;

    return [{
      id,
      label,
      value: formatFilterValue(config, value),
      clear: () => column.setFilterValue(undefined),
    }];
  });

  const hasGlobalFilter = Boolean(String(globalFilter ?? '').trim());
  if (hasGlobalFilter) {
    activeFilters.push({
      id: '__global',
      label: 'Search',
      value: String(globalFilter),
      clear: () => table.setGlobalFilter(''),
    });
  }

  const hasClearableFilters = activeFilters.some(
    (filter) => filter.id !== '__global' || clearGlobalFilterOnClear,
  );
  if (activeFilters.length === 0) return null;

  return (
    <div
      role="group"
      aria-label="Active filters"
      className="mt-2 flex flex-wrap items-center gap-2"
    >
      {activeFilters.map((filter) => (
        <span
          key={filter.id}
          className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-xs text-primary-700"
        >
          <span className="font-medium">{filter.label}:</span>
          <span>{filter.value}</span>
          <button
            type="button"
            aria-label={`Clear ${filter.label} filter`}
            onClick={filter.clear}
            className="ml-0.5 rounded-full px-1 font-semibold hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-brand/30"
          >
            ×
          </button>
        </span>
      ))}
      {hasClearableFilters && (
        <button
          type="button"
          onClick={() => {
            table.setColumnFilters([]);
            if (clearGlobalFilterOnClear) table.setGlobalFilter('');
          }}
          className="text-xs font-medium text-gray-600 underline decoration-gray-300 underline-offset-2 hover:text-gray-900"
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default DataTableFilterIndicators;
